export const publicationStatus = {
  DEFINED: 'DEFINED',
  PUBLISHING: 'PUBLISHING',
  PUBLICATED: 'PUBLICATED',
  WITH_ERRORS: 'WITH_ERRORS',
};
